const gregorian_es_locale = {
    name: "gregorian_es_locale",
    months: [
      ["enero", "jan"],
      ["febrero", "feb"],
      ["marzo", "mar"],
      ["abril", "apr"],
      ["mayo", "may"],
      ["junio", "jun"],
      ["julio", "jul"],
      ["agosto", "aug"],
      ["septiembre", "sep"],
      ["octubre", "oct"],
      ["noviembre", "nov"],
      ["diciembre", "dec"],
    ],
    weekDays: [
      ["sabado", "sab"],
      ["domingo", "dom"],
      ["lunes", "lun"],
      ["martes", "mar"],
      ["miercoles", "mie"],
      ["jueves", "jue"],
      ["viernes", "vie"],
    ],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: [
      ["AM", "am"],
      ["PM", "pm"],
    ],
  };
  
  export default gregorian_es_locale;